import React, { Component } from 'react';

export default class Footer extends Component {
  render() {
    const { personalInfo } = this.props;
    return (
      <footer>
        <div className="col-md-12 col-xs-12">
        <span id="footer-text-wrap">
        Built by {personalInfo.name}.
        </span>
        </div>
      </footer>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Footer.js
 **/